import type { ReactElement } from "react";
import { DownloadLandingPageContext } from "@external/DownloadLandingPageContext";
import { DownloadLandingPageContent } from "@external/DownloadLandingPageContent";
import type { RuntimeContext } from "@shared/RuntimeContextProvider";
import { RuntimeContextProvider } from "@shared/RuntimeContextProvider";
import { Route, Routes } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: false,
    },
    mutations: {
      retry: false,
    },
  },
});

function DownloadLandingPage({ context = "Shell" }: { context?: RuntimeContext }): ReactElement {
  return (
    <RuntimeContextProvider auth={false} context={context}>
      <QueryClientProvider client={queryClient}>
        <Routes>
          <Route
            element={
              <DownloadLandingPageContext>
                <DownloadLandingPageContent />
              </DownloadLandingPageContext>
            }
            path={"download"}
          />
        </Routes>
      </QueryClientProvider>
    </RuntimeContextProvider>
  );
}

export default DownloadLandingPage;
